import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/reports/wip")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/$reportId", params: { reportId: "46ea20b2-0714-5301-9429-98f518d93e66" }, replace: true });
  },
  component: () => null,
});
